/**
 * 资源查询服务
 * 定义接口
 */
const IEMapService = require('./IEMapService');

/**
 * 查询结果
 * @typedef G.service.IResourceQueryService~QueryResult
 * @type {Object}
 * @property {String} table 表名
 * @property {Object[]} list 结果列表
 * @property {Object} [list[n]] 结果记录
 * @property {String} [list[n].id] 数据id
 * @property {GeoJSON} [list[n].geom] 坐标
 * @property {String|Number|Boolean|Object|Object[]} [list[n][key]] 其他属性，默认关联的查询字段结果为关联表里的记录对象；一对多时，为对象数组
 */

/**
 * 分页查询结果
 * @typedef G.service.IResourceQueryService~PageQueryResult
 * @type {Object}
 * @property {Number} pageNo 页码
 * @property {Number} pageSize 每页记录数
 * @property {Number} total 总数
 * @property {Object[]} list 结果列表
 * @property {Object} [list[n]] 结果记录
 * @property {String} [list[n].id] 数据id
 * @property {GeoJSON} [list[n].geom] 坐标
 * @property {String|Number|Boolean|Object|Object[]} [list[n][key]] 其他属性，默认关联的查询字段结果为关联表里的记录对象；一对多时，为对象数组
 * 
 * @example
//
{
     pageNo:1,
     pageSize:10,
     total:101,
     list:[
          {
               id:"rescue_01",
               name:"xx救援队",
               //类型，关联字典表 
               type:{
                    code: "L01010101"
                    name: "综合救援队"
               },
               //人员，关联子表（一对多）
               person:[
                    {
                       "personname":"xxxx",
                       "persontel":"12335"
                    }
               ],
               geom:{
                    type:"Point",
                    coordinates:[116,39]
               }
          }
     ]
}


 */

/**
 * @classdesc 资源查询服务接口
 * @alias G.service.IResourceQueryService
 * @augments G.service.IEMapService
 * @param opts
 * @param opts.httpRequest {G.base.IHttpRequest} 请求对象
 * @param opts.url {String} 服务地址
 */
class IResourceQueryService extends IEMapService {
    constructor(opts) {
        super(opts);
    }

    /**
     * 分页查询
     * @param opts
     * @param opts.table {String} 查询表名
     * @param [opts.select] {String} 查询字段，默认为全部
     * @param [opts.where] {String} 属性过滤条件，name like '%酒店%' and districtCode = '110000'
     * @param [opts.geometry] {GeoJSON} 空间过滤条件
     * @param [opts.inputSr] {String} 空间过滤条件坐标系
     * @param [opts.spatialRel] {String} 空间关系，可选值[intersects,within]，默认为intersects
     * @param [opts.returnRelation] {Boolean} 是否返回关联信息，默认为false
     * @param [opts.relation] {Array} 自定义关联表信息集【预留参数】
     * @param [opts.relation[n]] {Object} 关联表信息
     * @param [opts.relation[n].table] {String} 关联表名
     * @param [opts.relation[n].localField] {String} 查询表关联字段
     * @param [opts.relation[n].foreignField] {String} 关联表关联字段
     * @param [opts.relation[n].selectFields] {String[]} 关联表查询的字段，不传则返回全部
     * @param [opts.relation[n].alias] {String} 返回的别名
     * @param [opts.relation[n].type] {String} 关联类型，one = 多对一或者一对一，many = 一对多，默认为one
     * @param [opts.sort] {String} 排序，如 name asc
     * @param [opts.pageSize] {Integer} 每页记录数，默认为10
     * @param [opts.pageNo] {Integer} 页数，从1开始计数
     * @returns {G.service.IResourceQueryService~PageQueryResult}
     */
    getPageList(opts) {}

    /**
     * 单表查询
     * @param opts
     * @param opts.table {String} 查询表名
     * @param [opts.select] {String} 查询字段，默认为全部
     * @param [opts.where] {String} 属性过滤条件，name like '%酒店%' and districtCode = '110000'
     * @param [opts.geometry] {GeoJSON} 空间过滤条件
     * @param [opts.inputSr] {String} 空间过滤条件坐标系
     * @param [opts.spatialRel] {String} 空间关系，可选值[intersects,within]，默认为intersects
     * @param [opts.returnRelation] {Boolean} 是否返回关联信息，默认为false
     * @param [opts.relation] {Array} 自定义关联表信息集
     * @param [opts.relation[n]] {Object} 关联表信息
     * @param [opts.relation[n].table] {String} 关联表名
     * @param [opts.relation[n].localField] {String} 查询表关联字段
     * @param [opts.relation[n].foreignField] {String} 关联表关联字段
     * @param [opts.relation[n].selectFields] {String[]} 关联表查询的字段，不传则返回全部
     * @param [opts.relation[n].alias] {String} 返回的别名
     * @param [opts.relation[n].type] {String} 关联类型，one = 多对一或者一对一，many = 一对多，默认为one
     * @param [opts.sort] {String} 排序，如 name asc
     * @returns {G.service.IResourceQueryService~QueryResult}
     */
    getList(opts) {}


    /**
     * 批量(多表)简单查询
     * @param opts
     * @param {Array} opts.tables  查询信息集
     * @param {Object} [opts.tables[n]]  单个表查询信息，同getList参数
     * @returns {G.service.IResourceQueryService~QueryResult[]}
     */
    getListBatch(opts) {}
}
module.exports = IResourceQueryService;